import React from "react";

const DataAreaContext = React.createContext({

});

export default DataAreaContext;